import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { Colors } from '@/constants/colors';
import { ComprehensiveStockAnalysis } from '@/types/perplexity.types';
import { SkeletonCard } from './SkeletonCard';

interface MarketStatusCardProps {
  data: ComprehensiveStockAnalysis['marketStatus'] | null | undefined;
  isLoading: boolean;
}

export const MarketStatusCard: React.FC<MarketStatusCardProps> = ({ data, isLoading }) => {
  if (isLoading || !data) {
    return <SkeletonCard lines={3} />;
  }

  return (
    <View style={styles.card}>
      <View style={styles.cardHeader}>
        <Ionicons name="stats-chart" size={20} color={Colors.primary} />
        <Text style={styles.cardTitle}>Market Status</Text>
      </View>

      <Text style={styles.cardText}>{data.summary}</Text>

      <View style={styles.divider} />

      <View style={styles.section}>
        <Text style={styles.label}>Price Action</Text>
        <Text style={styles.cardText}>{data.priceAction}</Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.label}>Daily Performance</Text>
        <Text style={styles.cardText}>{data.dailyPerformance}</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    backgroundColor: Colors.background.secondary,
    borderRadius: 12,
    padding: 16,
    marginBottom: 16,
    borderWidth: 1,
    borderColor: Colors.border.subtle,
  },
  cardHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
    gap: 8,
  },
  cardTitle: {
    fontSize: 16,
    fontWeight: '700',
    color: Colors.text.primary,
    flex: 1,
  },
  cardText: {
    fontSize: 14,
    lineHeight: 20,
    color: Colors.text.primary,
  },
  divider: {
    height: 1,
    backgroundColor: Colors.border.subtle,
    marginVertical: 12,
  },
  section: {
    marginBottom: 8,
  },
  label: {
    fontSize: 13,
    fontWeight: '600',
    color: Colors.text.secondary,
    marginBottom: 4,
  },
});
